import { isUndefinedOrNull } from '../../TypeHelpers';
import lastOrDefault from './lastOrDefault';
export default function last(array, predicate) {
    const value = lastOrDefault(array, predicate);
    if (isUndefinedOrNull(value)) {
        throw new Error("There is no last item matching the predicate!");
    }
    return value;
}
